<script>
import DataBrick, { DATA_BRICK_ENTITY_TYPE } from '@/V2/analytics/DataBrick';
import { getCustomerRiskLevelProperties } from '@/utils/customerRiskLevel';
import { RISK_LEVEL } from '@/constants/riskLevels';

export default {
  components: { DataBrick },
  props: {
    data: {
      type: Object,
      required: true,
      validator(value) {
        return [
          'low_risk',
          'medium_risk',
          'high_risk',
          'not_applicable_risk',
        ].every(
          (key) =>
            value[key] &&
            typeof value[key].count === 'number' &&
            typeof value[key].percentage === 'number',
        );
      },
    },
  },
  data() {
    return {
      title: 'Customer Risk Levels',
      subtitle: 'Breakdown of customer risk levels',
      roundToDecimalPlaces: 0,
      DATA_BRICK_ENTITY_TYPE,
    };
  },
  computed: {
    bricks() {
      const riskLevels = [
        { dataKey: 'low_risk', type: RISK_LEVEL.LOW },
        { dataKey: 'medium_risk', type: RISK_LEVEL.MEDIUM },
        { dataKey: 'high_risk', type: RISK_LEVEL.HIGH },
        { dataKey: 'not_applicable_risk', type: RISK_LEVEL.NOT_APPLICABLE },
      ];

      return riskLevels.map((level, idx) => {
        const riskData = this.data[level.dataKey];
        const properties = getCustomerRiskLevelProperties(level.type);

        return {
          id: idx,
          title: properties.label,
          percentage: `${riskData.percentage.toFixed(this.roundToDecimalPlaces)}%`,
          count: riskData.count,
          type: level.type,
          color: properties.iconColor,
          iconBackgroundColor: properties.iconBackgroundColor,
          icon: properties.icon,
        };
      });
    },
  },
  methods: {
    convertAnalyticsParamsToCustomersParams(analyticsParams) {
      const customersParams = {};

      if (analyticsParams.start_date && analyticsParams.end_date) {
        customersParams.startDate = analyticsParams.start_date;
        const endDate = new Date(analyticsParams.end_date);
        endDate.setDate(endDate.getDate() + 1);
        customersParams.endDate = endDate.toISOString().split('T')[0];
      }

      if (analyticsParams.customer_statuses) {
        customersParams.status = Array.isArray(
          analyticsParams.customer_statuses,
        )
          ? analyticsParams.customer_statuses.join(',')
          : analyticsParams.customer_statuses;
      }

      if (analyticsParams.tags) {
        customersParams.tag = Array.isArray(analyticsParams.tags)
          ? analyticsParams.tags.join(',')
          : analyticsParams.tags;
      }

      return customersParams;
    },
  },
};
</script>

<template>
  <div class="md chart-card d-flex flex-column i-radius-2xl">
    <div class="i-mb-8 header d-flex flex-column">
      <div class="title i-text-neutral-120 i-text-button-2">
        {{ title }}
      </div>
      <div v-if="subtitle" class="subtitle i-text-neutral-110 i-text-body-2">
        {{ subtitle }}
      </div>
    </div>

    <div class="chart-card__body d-flex flex-row align-items-center i-gap-6">
      <data-brick
        v-for="brick in bricks"
        :key="brick.id"
        :brick-data="brick"
        :entity="DATA_BRICK_ENTITY_TYPE.CUSTOMER_RISK_LEVELS"
        :style="{ flexGrow: 1 }"
        size="lg"
      ></data-brick>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chart-card {
  border: 1px solid $light-neutral-60;
  width: 100%;
  padding: map.get($increments, 10);

  &__body {
    height: 100%;
  }
}
</style>
